import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import GradeTable from '../pages/Apparaisal/GradeTable';
import PrimaryCategoryTable from '../pages/Apparaisal/PrimaryCategoryTable';
import TemplateTable from '../pages/Apparaisal/TemplateTable';
import MyteamactionTable from '../pages/Idp/MyteamactionTable';
import MyTeamidpTable from '../pages/Idp/MyTeamidpTable';
import DataTable from './DataTable';

function IdpTeamplateTab() {
  return (
    <Tabs
      defaultActiveKey="Training"
      id="justify-tab-example"
      className="mb-3 tempactive"
      justify
    >
      <Tab eventKey="Training" title="Training" className="custom-tab">
      
      <MyTeamidpTable/>
      </Tab>
      <Tab  eventKey="Action"  title="Action" className="custom-tab">
      <MyteamactionTable/>
      </Tab>
     
     
    </Tabs>
  );
}

export default IdpTeamplateTab;